var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("证件管理配置")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageSerch" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                staticStyle: { "margin-bottom": "16px" },
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("添加")]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "ID", prop: "id", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "证件名称", prop: "title", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "排序", align: "center", prop: "sort" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "lvKey", align: "center", prop: "lvKey" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                编辑\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn redColor1",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                删除\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.selectItem(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                查看\n              ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "证件id", prop: "num" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.editId,
                      placeholder: "请输入证件id",
                    },
                    model: {
                      value: _vm.ruleForm1.num,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "num", $$v)
                      },
                      expression: "ruleForm1.num",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "证件名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入证件名称" },
                    model: {
                      value: _vm.ruleForm1.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "name", $$v)
                      },
                      expression: "ruleForm1.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "证件级别KEY", prop: "key" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入证件级别KEY" },
                    model: {
                      value: _vm.ruleForm1.key,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "key", $$v)
                      },
                      expression: "ruleForm1.key",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入排序" },
                    model: {
                      value: _vm.ruleForm1.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "sort", $$v)
                      },
                      expression: "ruleForm1.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }